module.exports = __webpack_public_path__ + "img/mj.c930e9ec.png";